window._ = require('lodash')
window.$ = window.jQuery = require('jquery')

window.axios = require('axios')
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

window.inputmask = require('inputmask/dist/jquery.inputmask')
$(":input").inputmask()
$('input[type="tel"]').inputmask('+7 (999) 999-9999')

window.bootstrap = require('bootstrap')
window.moment = require('moment')